/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    RouteActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';


export const fetchRoutesEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.ROUTE_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, RouteActions.receiveRoutes))
);

export const fetchRouteEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.ROUTE_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, RouteActions.receiveRoute))
);

export const updateRouteEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.ROUTE_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, RouteActions.updatedRoute))
);

export const deleteRouteEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.ROUTE_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, RouteActions.deletedRoute))
);

export const createRouteEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.ROUTE_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => {
        if (action.post.type === 1) { // 1 === R_CURATE_BASIC
            // TODO: figure out what was meant for this case
        }
        return api(action.type, state$, null, action.post, RouteActions.createdRoute)
    })
);
